module.exports = __webpack_public_path__ + "static/img/comment_face_2.250ab44a.png";